import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  IzvestajFiskalnaKasaPageComponent,
  TipIzvestajaFiskalneKase,
} from './fiskalni-racun/izvestaj-fiskalna-kasa-page/izvestaj-fiskalna-kasa-page.component';
import { IzvestajPageComponent } from './izvestaj-page/izvestaj-page.component';
import { PoslovanjePageComponent } from './kpo-knjiga/kpo-knjiga-page/poslovanje-page.component';
import { IosIzvestajPageComponent } from './ios-izvestaj/ios-izvestaj-page/ios-izvestaj-page.component';
import { MaloprodajaPageIzvestajiComponent } from './maloprodaja/maloprodaja-page/maloprodaja-page-izvestaji.component';
import { VeleprodajaPageIzvestajiComponent } from './veleprodaja/veleprodaja-page-izvestaji/veleprodaja-page-izvestaji.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        // pathMatch: 'full',
        component: IzvestajPageComponent,
      },
      {
        path: 'poslovanje',
        data: {
          breadcrumb: 'Poslovanje',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: PoslovanjePageComponent,
          },
        ],
      },
      {
        path: 'fiskalna-kasa-dnevni-izvestaj',
        data: {
          breadcrumb: 'Dnevni izveštaj fiskalne kase',
          tipIzvestaja: TipIzvestajaFiskalneKase.DNEVNI,
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: IzvestajFiskalnaKasaPageComponent,
          },
        ],
      },
      {
        path: 'fiskalna-kasa-periodicni-izvestaj',
        data: {
          breadcrumb: 'Periodični izveštaj fiskalne kase',
          tipIzvestaja: TipIzvestajaFiskalneKase.PERIODICNI,
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: IzvestajFiskalnaKasaPageComponent,
          },
        ],
      },
      {
        path: '',
        component: IzvestajPageComponent,
      },
      {
        path: 'ios-izvestaj',
        data: {
          breadcrumb: 'IOS izveštaj',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: IosIzvestajPageComponent,
          },
        ],
      },
      {
        path: '',
        component: IzvestajPageComponent,
      },
      {
        path: 'maloprodaja-izvestaj',
        data: {
          breadcrumb: 'Maloprodaja izveštaj',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MaloprodajaPageIzvestajiComponent,
          },
        ],
      },
      {
        path: '',
        component: IzvestajPageComponent,
      },
      {
        path: 'veleprodaja-izvestaj',
        data: {
          breadcrumb: 'Veleprodaja izveštaj',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: VeleprodajaPageIzvestajiComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class IzvestajRoutingModule {}
